import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { bindActionCreators } from 'redux';
import * as AdminSettingAactions from './../../../actions/admin/adminSetting_action';
import * as FacilitiesActions from '../../../actions/facilities_actions';
import Header from '../../../components/header';
let screenIdentifier = 'requestforDeactivation';
import _ from 'lodash';
import { ModalDialogCommon } from '../../modal_dialog_common';

let RequestForDeactivation = React.createClass({
    getInitialState() {
        return {
            isUpdate: false,
            AdminSelectionData: null,
            AdminValue: null,
            form_submited: false,
            //showAddAdminSuccessModal: false,
            //showFailureModel: false,
            mobileCssClass: "inputText",

            Okmessage: null,
            showConfirmationModel: null,
            modal_msg: null,
        }
    },
    componentWillReceiveProps(nextProps) {
        if (this.state.form_submited && nextProps.AdminDeactivate) {
            this.refs.reason.value = '';
            this.refs.selectedAdmin.value = '';
            let facilitiesID = this.props.UserData.selectdUserFacilityID;
            this.props.Dispatch(AdminSettingAactions.getFacilityAdmins(facilitiesID));
            this.setState({ form_submited: false })
        }
        this.setState({ AdminSelectionData: nextProps.SelectAdmin.data });


    },
    componentDidMount() {
        let facilitiesID = this.props.UserData.selectdUserFacilityID;
        this.props.Dispatch(AdminSettingAactions.getFacilityAdmins(facilitiesID));
    },
    storeTypeHandler(e) {

    },
    selectionChanged(event) {
        event.target.value != "" ? event.target.parentElement.parentElement.parentElement.className = 'aj-dropdown' : event.target.parentElement.parentElement.parentElement.className = 'aj-dropdown error-border-bottom';
    },
    sendReqestDeactivation() {

        let reason = this.refs.reason.value.trim(),
            selectedAdmin = this.refs.selectedAdmin.value.trim();
        !reason.length ? this.refs.reason.className = "inputText error" : this.refs.reason.className = "inputText";
        selectedAdmin.length > 0 ? this.refs.selectedAdmin.parentElement.parentElement.parentElement.className = 'aj-dropdown' : this.refs.selectedAdmin.parentElement.parentElement.parentElement.className = 'aj-dropdown error-border-bottom';

        if (reason.length > 0 && selectedAdmin.length > 0) {

            var data = {
                "uniqueKey": this.props.UserDetails.data.uniqueKey,
                "id": selectedAdmin,
                "facilityId": this.props.UserData.selectdUserFacilityID,
                "reason": reason,
                "requestedBy": {
                    "id": this.props.UserDetails.data.id,
                }
            }
            this.setState({ showConfirmationModel: false, AdminSelectionData: '', form_submited: true });
            this.props.Dispatch(AdminSettingAactions.adminDeactivate(data));

        }
        else {

            this.setState({ Okmessage: "Please enter necessary fields to proceed." });
        }


    },
    removeUpdate() {
        this.setState({
            isUpdate: false
        })

    },

    closebox() {
        this.setState({ showConfirmationModel: false, adminerr: false, Okmessage: false });
    },
    closeBoxOnScuess() {
        this.setState({ Okmessage: false, adminerr: false, });
    },
    showConfirmationPopup() {
        let reason = this.refs.reason.value.trim(),
            selectedAdmin = this.refs.selectedAdmin.value.trim();
        !reason.length ? this.refs.reason.className = "inputText error" : this.refs.reason.className = "inputText";
        selectedAdmin.length > 0 ? this.refs.selectedAdmin.parentElement.parentElement.parentElement.className = 'aj-dropdown' : this.refs.selectedAdmin.parentElement.parentElement.parentElement.className = 'aj-dropdown error-border-bottom';
        if (reason.length > 0 && selectedAdmin.length > 0) {
            this.setState({ showConfirmationModel: true })
        } else {
            this.setState({ Okmessage: "Please enter necessary fields to proceed." });
        }


    },

    navigationHandler() {
    },

    no_empty(event) {
        event.target.value.trim().length > 0 ? event.target.className = 'inputText' : event.target.className = 'inputText error';
    },
    remove_error(event) {
        event.target.className = 'inputText';
    },
    render() {
        return (
            <div>
                <Header screenIdentifier={screenIdentifier} />

                <div className="row">
                    <div className="col-xs-6 no-padding staff-recovery">
                        <div className="aj-dropdown">
                            <div className="source">
                                <div className="question-selection">
                                    <select ref="selectedAdmin" onClick={this.selectionChanged} onFocus={this.selectionChanged} onBlur={this.selectionChanged} required>
                                        <option value="" default>Select Admin</option>
                                        {
                                            _.map(this.state.AdminSelectionData, (Data, key) => {
                                                return (
                                                    <option key={key} value={Data.id}>
                                                        {Data.firstName}{Data.lastName}  </option>
                                                )


                                            })}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="input-group">
                            <input type="text" className="inputText" maxLength="500" ref="reason" onFocus={this.remove_error} onBlur={this.no_empty} required />
                            <span className="floating-label">Add Reason</span>
                        </div>
                    </div>
                </div>





                <div className="row">
                    <div className="col-xs-12 no-padding recovery-buttons">
                        <button className="gray-button" onClick={this.showConfirmationPopup}>SUBMIT</button>

                    </div>
                </div>


                <div> {this.state.showConfirmationModel ? <ModalDialogCommon message={"Are you sure you want to submit a request to deactivate this account?"} cancel="true" action2={this.closebox} action={this.sendReqestDeactivation} /> : ""}</div>
                {this.state.Okmessage && <ModalDialogCommon message={this.state.Okmessage} action={this.closebox} />}
            </div>

        );
    }
});

let mapStateToProps = (state) => {


    return {
        UserData : state.User,
        UserDetails: state.User.loginData,
        SelectAdmin: state.AdminDashboard.SelectAdmin,
        AdminDeactivate: state.AdminDashboard.AdminDeactivateRequestResponse
    };

};

let mapDispatchToProps = (dispatch) => ({
    AdminSettingAactions: bindActionCreators(AdminSettingAactions, dispatch),
    Dispatch: dispatch
});
export default connect(mapStateToProps,
    mapDispatchToProps)(withRouter(RequestForDeactivation));



/** WEBPACK FOOTER **
 ** ./src/components/admin/clinicSettings/requestforDeactivation.js
 **/